import HeaderTitle from './HeaderTitle';

export default HeaderTitle;
